module.exports = __webpack_public_path__ + "static/media/plan-extension.15d4cd33.png";